import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
export var PrescriptionRow = function (_React$Component) {
  _inherits(PrescriptionRow, _React$Component);

  var _super = _createSuper(PrescriptionRow);

  function PrescriptionRow() {
    _classCallCheck(this, PrescriptionRow);

    return _super.apply(this, arguments);
  }

  _createClass(PrescriptionRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRender) this.props.onRender(this);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "col-md-10 messagecontainer ".concat(this.props.messageFrom == 'You' ? "darker" : "")
      }, React.createElement("p", null, React.createElement("a", {
        href: this.props.hyperlink,
        target: "_blank"
      }, this.props.displayText)), React.createElement("span", {
        className: "".concat(this.props.messageFrom == 'You' ? "time-right" : "time-left")
      }, this.props.messageFrom));
    }
  }]);

  return PrescriptionRow;
}(React.Component);